export default __webpack_public_path__ + "static/media/168.21c62e03.gif";